module.exports = __webpack_public_path__ + "static/media/page2_furba8.693d20d6.wav";